import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect, useRef } from 'react';
import { usePermissao } from './PermissaoProvider';
import { telaDaRota } from '../../routes/telasDasRotas';
import { Home } from '../../routes/RoutesNames';

/**
 * Barra a rota que o usuário não tem — inclusive a digitada na barra de endereço.
 *
 * O menu escondido é conforto; este componente é o que fecha o caminho de quem conhece a
 * URL. E nem ele é o portão de verdade: o portão está no servidor, no PermissaoMiddleware,
 * porque qualquer coisa no navegador é contornável. Aqui a função é não deixar a pessoa
 * abrir uma tela que vai dar erro em tudo que tentar.
 */
export default function RequirePermissao({ children }: { children: JSX.Element }) {
  const { podeVer, telas } = usePermissao();
  const location = useLocation();
  const avisou = useRef(false);

  const chave = telaDaRota(location.pathname);
  const liberado = podeVer(chave);

  useEffect(() => {
    // O aviso sai UMA vez por bloqueio. Sem o controle, cada redesenho do componente
    // empilharia um toast novo e a tela ficaria coberta de mensagens iguais.
    if (telas !== null && !liberado && !avisou.current) {
      avisou.current = true;
      toast('Você não tem permissão para acessar esta tela.', { type: 'warning' });
    }

    if (liberado) avisou.current = false;
  }, [liberado, telas]);

  // Ainda não se sabe quais são as telas. Não decide nada: devolver para a Home aqui
  // jogaria a pessoa para fora da tela que ela acabou de pedir, só porque a resposta
  // demorou 200ms. Ver PermissaoProvider.
  if (telas === null) return null;

  if (!liberado) return <Navigate to={Home} replace />;

  return children;
}
